import BoldText from '@/components/BoldText';
import IconButton from '@/components/IconButton';
import { emojiIcons } from '@/components/Icons/TimelineIcons';
import { Plan } from '@/constants/enum';
import { emojiIconList } from '@/constants/icons';
import { PATH } from '@/constants/path';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Banner, Link, Modal } from '@shopify/polaris';
import { MagicIcon } from '@shopify/polaris-icons';
import parse from 'html-react-parser';
import ReactDOMServer from 'react-dom/server';
import { useSelector } from 'react-redux';

interface IProps {
  open: boolean;
  onClose: () => void;
  handleAddText: (text: string) => void;
  onlyShowEmoji?: boolean;
  isInModalRuleLanguage?: boolean;
}

export default function EmojiModal({ open, onClose, handleAddText, onlyShowEmoji, isInModalRuleLanguage }: IProps) {
  const navigate = useConfirmationNavigate();
  const dataSettings = useSelector(dataSettingsSelector);
  const convertElementToString = (element: JSX.Element) => {
    return ReactDOMServer.renderToString(element);
  };
  return (
    <Modal size={onlyShowEmoji ? 'small' : 'large'} open={open} onClose={onClose} title="Icons">
      <Modal.Section>
        {!onlyShowEmoji ? (
          <div className="mb-8">
            <BoldText>Emoji</BoldText>
          </div>
        ) : null}
        <div id="editor-icon-container-id" className="editor-icon-container mb-8" style={{ gap: '10px' }}>
          {emojiIconList.map((icon) => (
            <div
              onClick={() => {
                handleAddText(icon.char);
                onClose();
              }}
              className="editor-emoji-icon"
              key={icon.char}
            >
              <IconButton cursorPointer>{parse(icon.char)}</IconButton>
            </div>
          ))}
        </div>
      </Modal.Section>

      {dataSettings.plan === Plan.FREE && !onlyShowEmoji ? (
        <div className="mt-8">
          <Banner tone="warning" icon={MagicIcon}>
            <Link
              onClick={() => {
                navigate(PATH.PRICING_PLAN);
              }}
            >
              Upgrade plan
            </Link>{' '}
            to access high-quality icons.
          </Banner>
        </div>
      ) : null}

      {onlyShowEmoji
        ? null
        : emojiIcons.map((item) => (
            <Modal.Section key={item.id}>
              <div className={dataSettings.plan === Plan.FREE ? 'disable-content' : ''}>
                <div className="mt-8">
                  <BoldText>{item.title}</BoldText>
                </div>
                <div className="editor-icon-container mt-8" style={{ gap: 10 }}>
                  {item.icons.map((icon) => (
                    <IconButton
                      onClick={() => {
                        if (dataSettings.plan === Plan.FREE) return;
                        handleAddText(
                          convertElementToString(
                            <img
                              src={icon.source}
                              width={icon.width ? 20 : 15}
                              height={icon.height ? 20 : 15}
                              alt="emoji icon"
                              className="emoji-icon-in-text-editor"
                            />,
                          ),
                        );
                        onClose();
                      }}
                      key={icon.id}
                    >
                      <img
                        style={{
                          cursor: dataSettings.plan === Plan.FREE ? 'default' : 'pointer',
                          userSelect: dataSettings.plan === Plan.FREE ? 'none' : undefined,
                        }}
                        className="timeline-layout--svg--icon"
                        src={icon.source}
                        width={icon.width || 20}
                        height={icon.height || 20}
                        alt="emoji icon"
                      />
                    </IconButton>
                  ))}
                </div>
              </div>
            </Modal.Section>
          ))}
    </Modal>
  );
}
